import { DefaultFinancialLogMutationReasons } from '../enums/defaultFinancialLogMutationReasons';
import { translateKeyLang } from '../translate/translate';

export function translateFinancialLogMutationReason(mutationReason: string) {
    return (Object.values(DefaultFinancialLogMutationReasons) as string[]).includes(mutationReason)
        ? translateKeyLang('nl', `fundingLogMutation.${mutationReason}`)
        : mutationReason;
}
